import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Form, FormikValues, useFormikContext } from "formik";

import ProgressSteps from "../../../../common/ProgressSteps/ProgressSteps";
import { useGetIrbSubmissionInfoLazyQuery } from "../../../../../generated/graphql";
import CreatePageFormFooter from "../../../../common/Form/CreatePageFormFooter/CreatePageFormFooter";
import IRBSubmission from "../../IRBSubmission/CreateIRBSubmission/IRBSubmission/IRBSubmission";
import StudyDetails from "../../IRBSubmission/CreateIRBSubmission/StudyDetails/StudyDetails";
import { createIRBInitData } from "../../IRBSubmission/utils";
import StudyDetailsIRBAddSub from "./StudyDetailsIRBAddSub/StudyDetailsIRBAddSub";
import { createIRBAdditionalSubInitData } from "../utils";

interface IProps {
  steps: number;
  setSteps(step: number): void;
  stepsInfo: string[];
}

const CreateIRBAdditionalSubmissionForm: FC<IProps> = (props) => {
  const { steps, setSteps, stepsInfo } = props;

  const { id } = useParams();

  const [getIrbById] = useGetIrbSubmissionInfoLazyQuery();

  const { setValues } = useFormikContext<FormikValues>();

  useEffect(() => {
    if (id) {
      const getData = async () => {
        const res = await getIrbById({
          variables: { id },
        });
        const newFormValues = {
          ...createIRBAdditionalSubInitData,
          ...res.data?.irb,
          isTermsAccepted: true,
        };
        setValues({ ...newFormValues });
      };
      getData();
    }
  }, [getIrbById, setValues, id]);

  return (
    <Form>
      <Container maxWidth={false}>
        <Card>
          <CardContent className="pd-x-32 pd-t-32 pd-b-20">
            <Box className="mg-b-40">
              <Typography className="mg-b-10" variant="h2" component="h2">
                New MIRB additional submission
              </Typography>
              <ProgressSteps stepsInfo={stepsInfo} currentStep={steps} />
            </Box>
            <Grid container className="justify-content-center">
              <Grid item xs={12} md={10} lg={10}>
                {steps === 0 && <StudyDetailsIRBAddSub />}
                {steps === 1 && <IRBSubmission />}

                <CreatePageFormFooter
                  setSteps={setSteps}
                  steps={steps}
                  stepsInfo={stepsInfo}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
    </Form>
  );
};

export default CreateIRBAdditionalSubmissionForm;
